/**
 * Reusable form component building maps
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import global components
import Base from '../BaseComponent.js.jsx';

import mapUtils from '../../utils/mapUtils';

// import third-party libraries
import { GoogleMap, Marker, Polygon, withGoogleMap, withScriptjs } from 'react-google-maps';
const { compose, withProps, lifecycle } = require("recompose");
const { DrawingManager } = require("react-google-maps/lib/components/drawing/DrawingManager");
const { StandaloneSearchBox } = require("react-google-maps/lib/components/places/StandaloneSearchBox");

const MapSearchBox = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=AIzaSyDwaEV_97GKqXGA55ky22DrsSaZQzj9uuA&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
  }),
  lifecycle({
    componentWillMount() {
      const refs = {};
      this.setState({
        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },
        onPlacesChanged: () => {
          this.props.handleMapSearch(refs.searchBox.getPlaces());
        },
        handleKeyPress: (e) => {
          console.log('press')
          if(e.key === "Enter") {
            e.preventDefault();
          }
        }
      })
    },
  }),
  withScriptjs
)(props => {
  return (
    <div className="input-group" style={{marginBottom:"0px"}}>
      { props.label ?
          <label htmlFor={props.name}>{props.label}</label>
        :
          null
      }
      <StandaloneSearchBox
        bounds={props.searchBounds}
        onPlacesChanged={props.onPlacesChanged}
        ref={props.onSearchBoxMounted}
      >
        <input
          defaultValue={props.value}
          onKeyPress={props.handleKeyPress}
          placeholder="Try 'Raleigh, NC'"
          type="text"
        />
      </StandaloneSearchBox>
      <small className="help-text"><em>{props.helpText}</em></small>
    </div>
  )}
);

export default MapSearchBox;



// WEBPACK FOOTER //
// global/components/maps/MapSearchBox.js.jsx